import { defineStore } from 'pinia';
import { TABLE_SETTINGS } from 'SharedDir/constants/table-settings';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { Filters } from 'PortalDir/modules/UsefulLinks/composables/usePublicUsefulLinksFilters';
import { UsefulLinks } from 'SharedDir/declarations/useful-links';

export interface UsefulLinksStateInterface {
  usefulLinksList: Array<UsefulLinks.UsefulLinksBare>;
  usefulLinks: UsefulLinks.UsefulLinksFull | object;
  pagination: PaginationParams<any>;
  filters: Filters;
}
export const useUsefulLinksStore = defineStore('useful-links', {
  state: () =>
    <UsefulLinksStateInterface>{
      usefulLinksList: [],
      usefulLinks: {},
      pagination: {
        page: 1,
        rowsPerPage: TABLE_SETTINGS.ROWS_PER_PAGE,
        rowsNumber: 1,
        sortBy: 'id',
        descending: false,
      },
      filters: {
        name: null,
        fromDate: null,
        toDate: null
      },
    },

  getters: {},

  actions: {
    setUsefulLinksList(value: Array<any>) {
      this.usefulLinksList = value;
    },
    setUsefulLinksPagination(value: object) {
      this.pagination = value;
    },
    setUsefulLinksFilter(value) {
      this.filters = value;
    },
    setUsefulLinks(value) {
      this.usefulLinks = value;
    },
  },
});
